import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './WizardPage.html?raw';
import "../GenericDialog/GenericDialog";
import _WidgetBaseSP from 'more/_WidgetBaseSP';


//import DataItems = require("DataItems");


class WizardPage extends compose(_WidgetBaseSP) {
    templateString: any = template;

    widgetContainer: HTMLElement;
    summaryContainer: HTMLElement;

    private widgetNode: any = null;// _WizardControlBase = null;
    private targetScope: any = null;
    private isSelected: boolean = false;
    private valid: boolean = false;
    private summary: any = "";

    // das sind die Properties (function, bool, text, ...) am targetscope, wo wir valid-Flag und summary abrufen können
    private summaryProperty;
    private validationProperty;

    order: number = -1;

    setVisibility(mode: "visible" | "summary" | "hidden") {
        this.UiModder.domClass.add(this.widgetContainer, "w3-hide");
        this.UiModder.domClass.add(this.summaryContainer, "w3-hide");
        if (mode == "summary") {
            let value = this.widgetNode.getSummary();
            this.UiModder.domAttr.set(this.summaryContainer, "innerHTML", value);
            this.UiModder.domClass.remove(this.summaryContainer, "w3-hide");
        }

        if (mode == "visible") {
            this.UiModder.domClass.remove(this.widgetContainer, "w3-hide");
        }
    }

    private _onGlobalClick(evt: MouseEvent): void {
        
    }

    setWidget(targetScope: any,
        visibleNode: HTMLElement,
        changeEventname: string,
        validationProperty: string,
        summaryProperty: string): void {
        if (visibleNode == null || targetScope == null ) {
            return;
        }

        this.widgetNode = visibleNode;
        this.targetScope = targetScope;

        if (changeEventname) {
            on(targetScope, changeEventname, lang.hitch(this, this._onWidgetChangeEvent, validationProperty, summaryProperty));
        }

        this.UiModder.domConstruct.place(visibleNode, this.widgetContainer);
    }

    isValid(): boolean {
        return this.valid;
    }

    //setValue(...args): void {
    //    if (this.widgetNode) {
    //        lang.partial(this.widgetNode.setValue, args);
    //    }
    //}

    collapse(): void {

    }  

    expand(): void {

    }

    private _onWidgetChangeEvent(validationProperty: string, summaryProperty: string, value: any) {
        //debugger;
        if (validationProperty) {
            let type = typeof (this.targetScope[validationProperty]);
            if (type == "function") {
                this.valid = this.targetScope[validationProperty]();
            } else if (type == "boolean") {
                this.valid = this.targetScope[validationProperty];
            } else if (type == "number") {
                this.valid = this.targetScope[validationProperty] >= 1;
            }
        } else {
            this.valid = true;
        }

        this._setSummary(summaryProperty);
        
        //console.debug("wizardpage - _onWidgetValidationEvent", value, this.targetScope[validationProperty], this.valid);

        this.emit("validation", this.valid);
        
    }

    private _setSummary(summaryProperty: string) {
        if (summaryProperty) {
            //debugger;
            let type = typeof (this.targetScope[summaryProperty]);
            let newSummary = null;
            if (type == "function") {
                newSummary = this.targetScope[summaryProperty]();
            } else if (type == "string") {
                newSummary = this.targetScope[summaryProperty];
            } else if (type == "number") {
                newSummary = (<number>this.targetScope[summaryProperty]).toString();
            } else if (type == "object") {
                newSummary = (<object>this.targetScope[summaryProperty]).toString();
            }

            if (newSummary != this.summary) {
                this.summary = newSummary;
                type = typeof (this.summary);
                if (type == "string") {
                    this.UiModder.domAttr.set(this.summaryContainer, "innerHTML", this.summary);
                } else if (this.summary != null){
                    this.UiModder.domAttr.set(this.summaryContainer, "innerHTML", this.summary.toString());
                }
                this.emit("newSummary", this.summary);
            }
        }
    }


    getSummary() {
        return this.summary;
    }

    private _onClick_SummaryContainer(evt: MouseEvent) {
        this.emit("requestSwitch");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.addSubscription("/Global/Click", lang.hitch(this, this._onGlobalClick));

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.PitHelper._structureFormat = "json";

    }
}

export default mdsWidget(WizardPage);